export function loadImgBlob(url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';

    xhr.onload = function (event) {
      var blob = xhr.response;
      var url = URL.createObjectURL(blob);
      resolve(url);
    };

    xhr.onerror = function (e) {
      reject(e);
    };

    xhr.send(null);
  });
}